import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Home from "../Pages/Home";
import SellMyExotic from "../Pages/SellMyExotic";
import Layout from "../components/Common/Layout";
import AboutUs from "../components/Home/AboutUs";
import ContactUs from "../components/Home/ContactUs";
import WhyUs from "../Pages/WhyUs";
import ThankYou from "../components/Common/ThankYou";
import Srp from "../Pages/Srp";
import Vdp from "../Pages/Vdp";
const AppRoutes = () => {

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <Layout>
                        <Routes>
                            <Route index element={<Home />} />
                            <Route path="/" element={<Home />} />
                            <Route path="/about-us" element={<AboutUs />} />
                            <Route path="/why-us" element={<WhyUs />} />
                            <Route path="/sell-my-exotic" element={<SellMyExotic />} />
                            <Route path="/contact-us" element={<ContactUs />} />
                            <Route path='/thank-you' element={<ThankYou />} /> 
                            <Route path='/inventory' element={<Srp />} /> 
                            <Route path='/vdp' element={<Vdp />} /> 
                        </Routes>
                    </Layout>
                }
            />
            <Route path="*" element={<Navigate to={"/"} replace />} />
        </Routes>
    );
};

export default AppRoutes;
